// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2730":"93a8d864","6745":"aff6bf68"}[chunkId] + ".chunk.css";
};